// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T6Vv","type":"styles_type__2Xt0F","choices":"styles_choices__32kQt"};